import { MAX_LINES_IN_ROSTER } from '@/constants';
import { APP_NAME, MAX_IMAGE_SIZE } from '@/constants/stringVars';

const onboardingMessages = {
  userOnboardingTitle: `Welcome to ${APP_NAME} - We Deliver Wholeness.`,
  userOnboardingDescription: `We invite you to join us and let ${APP_NAME} help your organization with everything related to mental health.`,
  proceed: 'Proceed',
  yourEmailAddress: 'Your email address',
  iAgreeTo: 'I agree to',
  termsOfUse: 'Terms of Use',
  and: 'and',
  privacyPolicy: 'Privacy Policy',
  termsOfInfoTooltip: `By checking this box, you acknowledge that you’ve read and agreed to ${APP_NAME}’s User Agreement, Privacy Policy, and Community Standards, and you consent to the collection and use of your information as described in those documents.`,
  yourStoryMatters: 'Your story matters.',
  yourStoryMattersDescription:
    'We ask a few personal details so we can better understand you — and guide your journey with resources that fit who you are. \n\nYour information stays private and is used only to personalize your experience and support your growth within the MyOmnia Wholeness Platform and community.',
  organizationOnboardingDescription: `We invite you to join us and let ${APP_NAME} help your organization with everything related to mental health.`,
  uploadCompanyLogoTitle: 'Upload Company Logo',
  uploadCompanyLogoSubtitle: "Use your brand to customize your team's experience.",
  uploadCompanyLogoDescription: `File requirements - Use a square image at least 200x200 pixels, ${MAX_IMAGE_SIZE} or less.`,
  uploadLogo: 'Upload Logo',
  uploadDifferentLogo: 'Upload Different Logo',
  previewWillBeShownHere: 'Preview will be shown here',
  goBack: 'Go back',
  continue: 'Continue',
  createYourRosterTitle: 'Create your Roster',
  createYourRosterSubtitle: 'Easily add members to your roster by using the form below.',
  createYourRosterDescriptionManual: 'Alternatively you can use CSV, to see how click the tab Upload CSV below.',
  createYourRosterDescriptionCSV: 'Or, enter the data manually. To see how click the tab Manually Add below.',
  createYourRosterCSVSubtitle: 'Use our template to easily add all your organization members.',
  createYourRosterCSVSubtitleDescription: 'Make sure you follow these simple steps to upload CSV correctly.',
  downloadOurRosterTemplate: 'Download our Roster Template (CSV)',
  downloadRosterTemplate: 'Download Roster Template',
  downloadRosterTemplateDescription:
    'Download the Template and Fill out the Roster without adjusting any of the columns. Be sure to fill in each column for each user to prevent errors.',
  uploadYourCompletedRoster: 'Upload Your Completed Roster',
  uploadUpdatedToYourRoster: 'Upload Updates to Your Roster',
  uploadYourRosterDescription: `Now that you've modified the template with your team's info, you're ready to upload it here! You can upload up to 100 members per batch and later on you can add more from Organization’s Roster page`,
  uploadYourUpdatedRosterDescription: `Now that you've modified the template with your team's info, you're ready to upload it here! You can upload up to 100 members per batch.`,
  uploadCSV: 'Upload CSV',
  previewYourRosterTitle: 'Preview your Roster',
  previewYourRosterSubtitle: 'You can see how we loaded your data, make sure it all looks good.',
  previewYourRosterDescription: 'If there are any errors make sure you go back and upload new CSV.',
  tooManyRecordsInRosterFile: `There are too many records in the roster file. Please add a maximum of ${MAX_LINES_IN_ROSTER} people.`,
  looksGood: 'Looks good, finish setup!',
  eulaNotAcceptedProperly: 'EULA not accepted properly. Please re-check.',
  emailSuccessfullyVerified: 'You have successfully verified your email.',
  emailNotVerifiedSuccessfully: 'Wrong credentials or expired token',
  resetPassword: 'Reset Your Password',
  pleaseEnterNewPasswordBelow: 'Please enter your new password below.',
  checkEmailOrContactAdmin: 'Please check your email or contact your administrator.',
  passwordSetupUnsuccessful: 'Password setup unsuccessful.',
  createYourPassword: 'Next, create your password.',
  passwordMustContain: 'Password must contain:',
  password8chars: '8+ characters',
  passwordLowercase: '1 lowercase letter',
  passwordUppercase: '1 uppercase letter',
  passwordNumberOrSpecialChar: '1 number or special character',
  listItemDot: '•',
};

export default onboardingMessages;
